import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Autor',
        path: '/biblioteca/bibautor',
        name: 'bibautor',
        component: () => import('@/views/biblioteca/bibautor/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_AUTORNOVO_MENU_1300800599],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Autores',
        path: '/biblioteca/bibautor/cadastro/:id?',
        parent: 'bibautor',
        name: 'bibautor_create',
        component: () => import('@/views/biblioteca/bibautor/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_AUTORNOVO_MENU_1300800599],
        },
        goesToMenu: true,
    },
]
